/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';

export interface FinancingSourcesCreditsRetrieve$Params {
  /**
   * A unique integer value identifying this кредит.
   */
  id: number;
}

export function financingSourcesCreditsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditDto>;
    }),
  );
}

financingSourcesCreditsRetrieve.PATH = '/api/financing_sources/credits/{id}/';
